import {log, logError} from '../webUtils'
import {selectPlaylist
  , unselectPlaylist
  , deleteMedia} from '../actions/mediaActions'

/*
Sound playlist
*/

const playlists = (state = [], action) => {
  switch (action.type) {
    case 'ADD_PLAYLIST':
      var id= Math.max(0, ...state.map(f => f.id)) + 1;
      action.asyncDispatch(selectPlaylist({id:id}));
      return [...state,
        {
          id: id,
          name: action.name,
          mediaIds: [],
          activityId: action.activityId,
        }
      ]
    case 'SELECT_PLAYLIST':
      return state.map(playlist => {
        if(playlist.id === action.id) {
          return {...playlist, isActive: true};
        }
        else if (playlist.isActive) {
          return {...playlist, isActive: false};
        }
        else
          return playlist;
      })
    case 'CHANGE_PLAYLIST_NAME':
      return state.map(playlist => {
        //console.log('value '+action.value+' id '+playlist.id+' actionid'+action.id)
        if(playlist.id === action.id) {
          var newPlaylist = {...playlist};
          newPlaylist[action.name] = action.value;
          return newPlaylist;
        }
        return playlist;
      })
    case 'DELETE_PLAYLIST':
      var playlist = state.find(({ id }) => id == action.id);
      if(typeof playlist !== 'undefined' && playlist.isActive)
        action.asyncDispatch(unselectPlaylist());
      if(typeof playlist !== 'undefined') {
        for(let mediaId of playlist.mediaIds) {
          action.asyncDispatch(deleteMedia({mediaId}));
        }
      }
      return state.filter(({ id }) => id !== action.id);

    case 'REGISTER_MUSIC':
      return state.map(playlist => {
        if(playlist.id == action.groupId) {
          let newMediaIds = playlist.mediaIds.slice();
          newMediaIds.push(action.id);
          playlist.mediaIds = newMediaIds;
          return playlist;
        }
        else
          return playlist
      })
    case 'INSERT_MUSIC':
      return state.map(playlist => {
        if(playlist.id == action.groupId) {
          let newMediaIds = playlist.mediaIds.slice();
          newMediaIds.splice(action.index, 0, action.id);
          playlist.mediaIds = newMediaIds;
          return playlist;
        }
        else
          return playlist
      })
    case 'DELETE_MUSIC':
      return state.map(playlist => {
        if(playlist.id == action.groupId) {
          playlist.mediaIds = playlist.mediaIds.filter(
            (item) => item != action.id
          );
          return playlist;
        }
        else
          return playlist
      })
// CLIENT ONLY
    case 'PUSH_ACTIVITY_CONTENT':
      if(typeof action.data.playlists === 'undefined') {
        log ('Undefined "state.playlists" from server.')
        return state;
      }
      else {
        return action.data.playlists.map(playlist => {
          var previousPlaylist = state.find(({ id }) => id === playlist.id);
          if(typeof previousPlaylist !== 'undefined' && previousPlaylist.isActive)
            playlist.isActive = true;
          return playlist;
        });
      }
    case 'SET_ACTIVE_CATEGORY':
      if(action.category == 'playlist')
        return state;
      else {
        return state.map(playlist => {
          if (playlist.isActive) {
            return {...playlist, isActive: true};
          }
          return playlist;
        })
      }

// SERVER ONLY
    case 'SET_STATE_FROM_DATABASE':
      if(typeof action.state.playlists === 'undefined') {
        log ('Undefined "state.playlists" from server.')
        return state;
      }
      else {
        return action.state.playlists;
      }
    default:
      return state
  }
}

export default playlists
